









import Vue from 'vue';
import { stripSpecialCharacters } from '../../../common/helper/strings';

export default Vue.extend({
  name: 'JerseyField',
  data() {
    return { value: '' };
  },
  props: { title: String, modelName: String },
  computed: {
    model: {
      get() {
        return (this as any).$store.state[(this as any).modelName];
      },
      set(val: string) {
        if (val.length > 30) {
          return (this as any).$store.state[(this as any).modelName];
        }
        const stippedVal = stripSpecialCharacters(val);
        (this as any).$store.commit(
          `set_${(this as any).modelName}`,
          stippedVal,
        );
        return stippedVal;
      },
    },
  },
  mounted() {},
});
